/* ============================================================================
   ACHEKO × Shopify — commerce integration layer
   ----------------------------------------------------------------------------
   Strategy: keep the ACHEKO front-end exactly as designed; hand off the cart to
   Shopify's secure hosted checkout via a cart permalink. Shopify is the source
   of truth for price / variants / inventory / payment.

   Store:   ACHEKO  (acheko.com)  ·  currency ILS
   Data below is generated from the live Shopify Admin API (numeric variant IDs
   are what cart permalinks require).  Re-run scripts/sync-catalog to refresh.
   ========================================================================== */
(function () {
  'use strict';

  // Domain used to build the Shopify checkout link.
  // Keep this pointed at the domain that Shopify serves the storefront on.
  //  - Today that is 'acheko.com' (the Shopify primary domain) — works as-is.
  //  - If you later repoint acheko.com to THIS deployed site, you must move the
  //    Shopify checkout to another domain (a checkout subdomain, or unset the
  //    primary domain so 'jg05er-q5.myshopify.com' stops redirecting) and set it here.
  var SHOP_DOMAIN = 'acheko.com';

  /* Live Shopify catalog. Keyed by the ACHEKO route key (#/product/<key>).
     `id` values are NUMERIC Shopify ProductVariant ids (for /cart permalinks). */
  var CATALOG = {
    'grip-socks': {
      productGid: 'gid://shopify/Product/9482231349503',
      handle: 'acheko-grip-socks-pro-series',
      title: 'PRO SERIES GRIP SOCKS',
      sizes: ['37-42', '43-47'],
      defaultSize: '43-47',
      /* qty bundles are SEPARATE Shopify products (real discounted bundles) */
      bundles: {
        single: { '37-42': { id: '48471877812479', price: 120 }, '43-47': { id: '48471877845247', price: 120 } },
        duo:    { '37-42': { id: '48471885250815', price: 220 }, '43-47': { id: '48471885283583', price: 220 } },
        trio:   { '37-42': { id: '48471885644031', price: 270 }, '43-47': { id: '48471885676799', price: 270 } }
      }
    },
    'shinguards': {
      productGid: 'gid://shopify/Product/9482176692479',
      handle: 'acheko-shin-guards-pro-series',
      title: 'PRO SHINGUARDS',
      single: { id: '48471730684159', price: 75 }
    },
    'grip-straps': {
      productGid: 'gid://shopify/Product/9482176987391',
      handle: 'acheko-straps-pro-series',
      title: 'PRO GRIP STRAPS',
      single: { id: '48471730979071', price: 75 }
    },
    'profit-sleeve': {
      productGid: 'gid://shopify/Product/9482176233727',
      handle: 'acheko-sleeve-socks-pro-series',
      title: 'PRO-FIT SLEEVE SOCKS',
      /* Shopify variants: Color (Dark Blue / Pink) × Size (37-42 / 43-47) */
      colors: [
        { id: 'dark-blue', name: 'כחול כהה', hex: '#1f2a44' },
        { id: 'pink',      name: 'ורוד',     hex: '#e8a0b4' }
      ],
      sizes: ['37-42', '43-47'],
      defaultColor: 'dark-blue',
      defaultSize: '43-47',
      variants: {
        'dark-blue': { '37-42': { id: '48471730127103', price: 65 }, '43-47': { id: '48471730159871', price: 65 } },
        'pink':      { '37-42': { id: '48471730192639', price: 65 }, '43-47': { id: '48471730225407', price: 65 } }
      }
    }
  };

  /* Resolve a selection {key, color, size, bundle} -> {variantId, price}. */
  function resolve(sel) {
    sel = sel || {};
    var p = CATALOG[sel.key];
    if (!p) return null;

    if (p.single) return { variantId: p.single.id, price: p.single.price };

    if (sel.key === 'grip-socks') {
      var bundle = (sel.bundle && p.bundles[sel.bundle]) ? sel.bundle : 'single';
      var gsize = (sel.size && p.bundles[bundle][sel.size]) ? sel.size : p.defaultSize;
      var gv = p.bundles[bundle][gsize];
      return gv ? { variantId: gv.id, price: gv.price } : null;
    }

    if (sel.key === 'profit-sleeve') {
      var color = (sel.color && p.variants[sel.color]) ? sel.color : p.defaultColor;
      var ssize = (sel.size && p.variants[color][sel.size]) ? sel.size : p.defaultSize;
      var sv = p.variants[color][ssize];
      return sv ? { variantId: sv.id, price: sv.price } : null;
    }
    return null;
  }

  window.ACHEKO_SHOPIFY = { domain: SHOP_DOMAIN, currency: 'ILS', catalog: CATALOG, resolve: resolve };

  /* ---- Align on-page price displays to Shopify (source of truth) ----
     The PDP components read prices off global data objects defined in the
     external *.jsx. Patch those once they exist so displayed prices match the
     store (the cart/checkout already use Shopify prices via resolve()). */
  function whenGlobal(name, cb) {
    if (window[name]) return cb(window[name]);
    setTimeout(function () { whenGlobal(name, cb); }, 30);
  }
  whenGlobal('GRIP_PRODUCT', function (P) {
    P.price = 120; P.priceOriginal = 120; P.discount = 0;   // no compare-at set in Shopify
    if (Array.isArray(P.bundles)) {
      P.bundles = [
        { qty: 1, price: 120, pricePer: 120, save: 0,  label: '1 PAIR',  labelHe: 'זוג אחד', tag: null },
        { qty: 2, price: 220, pricePer: 110, save: 20, label: '2 PAIRS', labelHe: '2 זוגות', tag: 'POPULAR' },
        { qty: 3, price: 270, pricePer: 90,  save: 90, label: '3 PAIRS', labelHe: '3 זוגות', tag: 'BEST' }
      ];
    }
  });
  whenGlobal('SHIN_PRODUCT',   function (P) { P.price = 75; });
  whenGlobal('STRAPS_PRODUCT', function (P) { P.price = 75; });

  /* ---- Cart: attach Shopify variant id + qty, persist to localStorage ---- */
  var LS_KEY = 'acheko_cart';

  function whenStore(cb) {
    if (window.__cartStore && typeof window.__cartStore.add === 'function') return cb(window.__cartStore);
    setTimeout(function () { whenStore(cb); }, 30);
  }

  whenStore(function (store) {
    var _add = store.add.bind(store);

    /* Wrap add(): resolve variant id, then honour an explicit qty. */
    store.add = function (item) {
      item = item || {};
      if (!item.variantId && item.shopify) {
        var r = resolve(item.shopify);
        if (r) { item.variantId = r.variantId; item.price = r.price; item.unitPrice = r.price; }
      }
      var q = Math.max(1, parseInt(item.qty, 10) || 1);
      _add(item);                                  // base add() forces qty:1, dedupes by item.id
      for (var i = 1; i < q; i++) store.inc(item.id);
    };

    /* Persist on every change. */
    store.sub(function (items) {
      try { localStorage.setItem(LS_KEY, JSON.stringify(items)); } catch (e) {}
    });

    /* Restore a saved cart once (re-add through the real pipeline). */
    try {
      var saved = JSON.parse(localStorage.getItem(LS_KEY) || '[]');
      if (saved && saved.length && store.get().length === 0) {
        saved.forEach(function (it) {
          _add(it);
          for (var i = 1; i < (it.qty || 1); i++) store.inc(it.id);
        });
      }
    } catch (e) {}
  });

  /* ---- Checkout handoff: build a Shopify cart permalink and redirect ---- */
  function buildCheckoutUrl() {
    var items = (window.__cartStore && window.__cartStore.get()) || [];
    var lines = items
      .filter(function (it) { return it.variantId; })
      .map(function (it) { return it.variantId + ':' + Math.max(1, it.qty || 1); });
    if (!lines.length) return null;
    return 'https://' + SHOP_DOMAIN + '/cart/' + lines.join(',');
  }

  function checkout() {
    var url = buildCheckoutUrl();
    if (url) { (window.top || window).location.href = url; return true; }
    return false;
  }

  window.ACHEKO = window.ACHEKO || {};
  window.ACHEKO.checkout = checkout;
  window.ACHEKO.buildCheckoutUrl = buildCheckoutUrl;

  /* Primary: intercept any checkout-intent button at the document level (capture
     phase) and hand off straight to Shopify's hosted checkout. Mirrors the SPA's
     own text matching, but redirects to Shopify instead of the retired mock flow. */
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('button, a') : null;
    if (!el) return;
    var txt = (el.textContent || '').trim().toLowerCase();
    var wantsCheckout = /^checkout/.test(txt) || txt.indexOf('לקופה') === 0 || txt.indexOf('לתשלום') === 0;
    if (!wantsCheckout) return;
    if (txt.indexOf('המשך') !== -1) return;   // "המשך לתשלום" = a step inside the flow, not the final CTA
    if (!buildCheckoutUrl()) return;          // empty / unresolved cart — let the SPA handle it
    e.preventDefault();
    e.stopImmediatePropagation();
    window.ACHEKO.checkout();
  }, true);

  /* Fallback: anything that still reaches the #/checkout route hands off too. */
  function maybeHandoff() {
    if ((window.location.hash || '').indexOf('#/checkout') === 0) {
      if (buildCheckoutUrl()) window.ACHEKO.checkout();
    }
  }
  window.addEventListener('hashchange', maybeHandoff);
  maybeHandoff();
})();
